import { SUPABASE_URL } from '../utils/supabase/url';
/**
 * Fires the server-side VoIP ring alongside the realtime offer.
 *
 * Fire and forget: a failed ring must never fail the call. A callee whose app
 * is running is still reached over Realtime, which stays the primary path — the
 * ring exists only to wake a backgrounded or terminated iPhone.
 */
import { projectId } from '../utils/supabase/info';
import { getAuthHeaders } from '../utils/supabase/client';

const RING_URL = `${SUPABASE_URL}/functions/v1/make-server-a476273b/call-signal/ring`;

export interface RingRequest {
  callId: string;
  calleeUserIds: string[];
  media: 'audio' | 'video' | 'huddle';
  chatId?: string;
  roomId?: string;
  participantIds?: string[];
  projectTitle?: string;
}

export const CallRingService = {
  async ring(request: RingRequest): Promise<void> {
    try {
      const headers = await getAuthHeaders({ 'Content-Type': 'application/json' });
      await fetch(RING_URL, {
        method: 'POST',
        headers,
        body: JSON.stringify(request),
        signal: AbortSignal.timeout(8000),
      });
    } catch {
      // Best effort by design. Realtime remains the primary path.
    }
  },
};
